import React, { createContext, useContext, useState } from "react";

const UserFormContext = createContext();

export const UpsellWidgetUserFormProvider = ({ children }) => {
    const [userFormProps, setUserFormProps] = useState({
        email: '',
        firstName: '',
        lastName: ''
    });
    const updateUserForm = (newState) => {
        setUserFormProps((prevState) => ({
            ...prevState,
            ...newState
        }))
    }
    return (
        <UserFormContext.Provider value={{ userFormProps, updateUserForm }}>
            {children}
        </UserFormContext.Provider>
    );
};

export const useUpsellWidgetUserFormContext = () => {
    const context = useContext(UserFormContext);
    if (!context) {
        throw new Error("user form must be used within a FormProvider");
    }
    return context;
};